var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "stats-audit-formula-form" }, [
    _c(
      "div",
      { staticClass: "sa-ff-tabs-box" },
      [
        _c(
          "div",
          { staticClass: "sa-ff-tabs-head" },
          [
            _c(
              "el-input",
              {
                staticClass: "sa-ff-tabs-head-input",
                attrs: { placeholder: "请输入内容" },
                on: { change: _vm.getAuditFormulaList },
                model: {
                  value: _vm.search,
                  callback: function ($$v) {
                    _vm.search = $$v
                  },
                  expression: "search",
                },
              },
              [
                _c("el-button", {
                  attrs: { slot: "append", icon: "el-icon-plus" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.addAuditFormula()
                    },
                  },
                  slot: "append",
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-tabs",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.listLoading,
                expression: "listLoading",
              },
            ],
            staticClass: "sa-ff-tabs",
            attrs: { type: "border-card", "tab-position": "left" },
            on: {
              "tab-click": function ($event) {
                _vm.errorMaps = {}
              },
            },
            model: {
              value: _vm.acAuditTabName,
              callback: function ($$v) {
                _vm.acAuditTabName = $$v
              },
              expression: "acAuditTabName",
            },
          },
          _vm._l(_vm.auditFormulaTabsList, function (audit) {
            return _c("el-tab-pane", {
              key: audit._id || audit.$hash,
              attrs: { label: audit.label, name: audit._id || audit.$hash },
            })
          }),
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "sa-ff-main" }, [
      _c("div", { staticClass: "sa-ff-main-box" }, [
        _c("div", { staticClass: "sa-ff-main-base" }, [
          _c("div", { staticClass: "sa-ff-from-title" }, [_vm._v("基础信息")]),
          _c(
            "div",
            { staticClass: "sa-ff-from-box" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.acAuditFormulaForm,
                    "label-width": "160px",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { lg: 6, sm: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "is-required",
                              attrs: {
                                label: "公式标识",
                                error: _vm.errorMaps[_vm.getItemKey("flag")],
                              },
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value:
                                    _vm.acAuditFormulaForm[
                                      _vm.getItemKey("flag")
                                    ],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.acAuditFormulaForm,
                                      _vm.getItemKey("flag"),
                                      $$v
                                    )
                                  },
                                  expression:
                                    "acAuditFormulaForm[getItemKey('flag')]",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { lg: 6, sm: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "is-required",
                              attrs: {
                                label: "公式中文名称",
                                error: _vm.errorMaps[_vm.getItemKey("name")],
                              },
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value:
                                    _vm.acAuditFormulaForm[
                                      _vm.getItemKey("name")
                                    ],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.acAuditFormulaForm,
                                      _vm.getItemKey("name"),
                                      $$v
                                    )
                                  },
                                  expression:
                                    "acAuditFormulaForm[getItemKey('name')]",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { lg: 6, sm: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "is-required",
                              attrs: {
                                label: "公式英文名称",
                                error:
                                  _vm.errorMaps[_vm.getItemKey("english_name")],
                              },
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value:
                                    _vm.acAuditFormulaForm[
                                      _vm.getItemKey("english_name")
                                    ],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.acAuditFormulaForm,
                                      _vm.getItemKey("english_name"),
                                      $$v
                                    )
                                  },
                                  expression:
                                    "acAuditFormulaForm[getItemKey('english_name')]",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "is-required",
                              attrs: {
                                label: "公式类型",
                                error: _vm.errorMaps[_vm.getItemKey("types")],
                              },
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value:
                                      _vm.acAuditFormulaForm[
                                        _vm.getItemKey("types")
                                      ].value,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.acAuditFormulaForm[
                                          _vm.getItemKey("types")
                                        ],
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "acAuditFormulaForm[getItemKey('types')].value",
                                  },
                                },
                                _vm._l(
                                  _vm.getInitDict("types", []),
                                  function (item) {
                                    return _c(
                                      "el-radio",
                                      {
                                        key: item.value,
                                        attrs: { label: item.value },
                                      },
                                      [_vm._v(" " + _vm._s(item.text) + " ")]
                                    )
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { lg: 6, sm: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "is-required",
                              attrs: {
                                label: "状态",
                                error: _vm.errorMaps[_vm.getItemKey("status")],
                              },
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value:
                                      _vm.acAuditFormulaForm[
                                        _vm.getItemKey("status")
                                      ].value,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.acAuditFormulaForm[
                                          _vm.getItemKey("status")
                                        ],
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "acAuditFormulaForm[getItemKey('status')].value",
                                  },
                                },
                                _vm._l(
                                  _vm.getInitDict("status", []),
                                  function (item) {
                                    return _c(
                                      "el-radio",
                                      {
                                        key: item.value,
                                        attrs: { label: item.value },
                                      },
                                      [_vm._v(" " + _vm._s(item.text) + " ")]
                                    )
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.acAuditFormulaForm[_vm.getItemKey("types")]
                                  .value == 2,
                              expression:
                                "acAuditFormulaForm[getItemKey('types')].value==2",
                            },
                          ],
                          attrs: { lg: 6, sm: 8 },
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "is-required",
                              attrs: {
                                label: "子表名称",
                                error:
                                  _vm.errorMaps[_vm.getItemKey("sub_table")],
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择" },
                                  on: {
                                    change: function ($event) {
                                      return _vm.selectChange("sub_table")
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.acAuditFormulaForm[
                                        _vm.getItemKey("sub_table")
                                      ].value,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.acAuditFormulaForm[
                                          _vm.getItemKey("sub_table")
                                        ],
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "acAuditFormulaForm[getItemKey('sub_table')].value",
                                  },
                                },
                                _vm._l(
                                  _vm.getInitDict("sub_table", []),
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.text,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { lg: 6, sm: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "is-required",
                              attrs: {
                                label: "统计公式用途",
                                error: _vm.errorMaps[_vm.getItemKey("used")],
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择" },
                                  on: {
                                    change: function ($event) {
                                      return _vm.selectChange("used")
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.acAuditFormulaForm[
                                        _vm.getItemKey("used")
                                      ].value,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.acAuditFormulaForm[
                                          _vm.getItemKey("used")
                                        ],
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "acAuditFormulaForm[getItemKey('used')].value",
                                  },
                                },
                                _vm._l(
                                  _vm.getInitDict("used", []),
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.text,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { lg: 6, sm: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "is-required",
                              attrs: {
                                label: "统计公式审核方式",
                                error:
                                  _vm.errorMaps[_vm.getItemKey("audit_method")],
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择" },
                                  on: {
                                    change: function ($event) {
                                      return _vm.selectChange("audit_method")
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.acAuditFormulaForm[
                                        _vm.getItemKey("audit_method")
                                      ].value,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.acAuditFormulaForm[
                                          _vm.getItemKey("audit_method")
                                        ],
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "acAuditFormulaForm[getItemKey('audit_method')].value",
                                  },
                                },
                                _vm._l(
                                  _vm.getInitDict("audit_method", []),
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.text,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { lg: 6, sm: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "is-required",
                              attrs: {
                                label: "统计公式权限",
                                error:
                                  _vm.errorMaps[_vm.getItemKey("permission")],
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择" },
                                  on: {
                                    change: function ($event) {
                                      return _vm.selectChange("permission")
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.acAuditFormulaForm[
                                        _vm.getItemKey("permission")
                                      ].value,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.acAuditFormulaForm[
                                          _vm.getItemKey("permission")
                                        ],
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "acAuditFormulaForm[getItemKey('permission')].value",
                                  },
                                },
                                _vm._l(
                                  _vm.getInitDict("permission", []),
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.text,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { lg: 6, sm: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "is-required",
                              attrs: {
                                label: "统计公式强制性类型",
                                error:
                                  _vm.errorMaps[
                                    _vm.getItemKey("mandatory_type")
                                  ],
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择" },
                                  on: {
                                    change: function ($event) {
                                      return _vm.selectChange("mandatory_type")
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.acAuditFormulaForm[
                                        _vm.getItemKey("mandatory_type")
                                      ].value,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.acAuditFormulaForm[
                                          _vm.getItemKey("mandatory_type")
                                        ],
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "acAuditFormulaForm[getItemKey('mandatory_type')].value",
                                  },
                                },
                                _vm._l(
                                  _vm.getInitDict("mandatory_type", []),
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.text,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "is-required",
                              attrs: {
                                label: "错误提示",
                                error: _vm.errorMaps[_vm.getItemKey("hint")],
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: 4,
                                  placeholder: "请输入内容",
                                },
                                model: {
                                  value:
                                    _vm.acAuditFormulaForm[
                                      _vm.getItemKey("hint")
                                    ],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.acAuditFormulaForm,
                                      _vm.getItemKey("hint"),
                                      $$v
                                    )
                                  },
                                  expression:
                                    "acAuditFormulaForm[getItemKey('hint')]",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "sa-ff-from-title" }, [_vm._v("审核编辑")]),
        _c("div", { staticClass: "sa-ff-main-top" }, [
          _c(
            "div",
            { staticClass: "sa-ff-code-edit" },
            [
              _c("DsfDmPythonEditor", {
                ref: "editor",
                attrs: {
                  editText: _vm.acAuditFormulaForm[_vm.getItemKey("content")],
                  theme: "vs",
                },
                on: { editLoaded: _vm.handleEditMounted },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "sa-ff-report-box" },
            [
              _c("DsfViewPart", {
                ref: "reportForm",
                staticClass: "sa-ff-report-viewpart",
                attrs: { path: "t/2023/B/form?isview=1&hash=LcNw1sLymkkdqcKn" },
                on: { ready: _vm.initProxyReportFormItems },
              }),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "sa-ff-main-bottom" },
        [
          _c("DsfButton", [_vm._v("验证")]),
          _c("DsfButton", { on: { click: _vm.save } }, [_vm._v("保存")]),
          _c(
            "DsfButton",
            { attrs: { type: "plain" }, on: { click: _vm.closePage } },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }